import React from "react";
import DOMPurify from "dompurify";

type Props = {
  content: any;
  messageFlagged?: any
};

const MessageContent: React.FC<Props> = ({ content, messageFlagged }): JSX.Element => {
  const createMarkup = (html: any) => {
    return {
      __html: DOMPurify.sanitize(html),
    };
  };

  return (
    <>
      <div
        className="flex flex-col my-2 rounded-br-full rounded-tr-full rounded-bl-full"
        style={{ background: "#E7E9EF" }}
      >
        <div
          className="font-nunito text-base my-3 mx-10"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            color: "#2A2B31",
          }}
          dangerouslySetInnerHTML={createMarkup(content)}
        />
      </div>
      {messageFlagged && (
        <div className="flex items-center ml-10">
          <div className="bg-bt-red-alert w-6 h-6 text-white font-nunito text-base rounded-full flex items-center justify-center">
            <p>!</p>
          </div>
          <p className="ml-4 text-bt-neutral-dark-grey text-xs font-nunito">This content has been reported by: {messageFlagged.user.name}</p>
        </div>
      )}
    </>
  );
};

export default MessageContent;
